var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wedding"},[_c('div',{staticClass:"background-animation"},[_vm._l((20),function(n){return _c('div',{key:n,staticClass:"floating-particle",style:({
           left: Math.random() * 100 + '%',
           animationDelay: Math.random() * 10 + 's',
           animationDuration: (Math.random() * 10 + 10) + 's',
           fontSize: (Math.random() * 30 + 20) + 'px'
         })},[_vm._v("\n      "+_vm._s(['❤️', '囍', '🌸', '🎉', '✨'][Math.floor(Math.random() * 5)])+"\n    ")])}),_c('div',{staticClass:"neon-overlay"}),_vm._l((30),function(n){return _c('div',{key:'particle'+n,staticClass:"golden-particle",style:({
           left: Math.random() * 100 + '%',
           top: Math.random() * 100 + '%',
           animationDelay: Math.random() * 5 + 's',
           width: (Math.random() * 6 + 2) + 'px',
           height: (Math.random() * 6 + 2) + 'px'
         })})})],2),_c('Editor')],1)}
var staticRenderFns = []

export { render, staticRenderFns }